import { type ComponentType, useEffect } from 'react';
import { useDidMount } from '@djs/react';
import { useAppContext } from '../../core';
import { PwaDisabledIos } from '../PwaDisabledIos';
import { PwaDisabledAndroid } from '../PwaDisabledAndroid';
import { PwaInstallDesktop } from '../PwaInstallDesktop';
import { PwaInstallSafari } from '../PwaInstallSafari';
import { PwaInstallOldSafari } from '../PwaInstallOldSafari';
import { PwaInstallChrome } from '../PwaInstallChrome';
import { PwaInstallOther } from '../PwaInstallOther';
import { linkIosManifest } from '../PwaInstallSafari/helpers';
import { PwaPage } from './enums';
import { usePageKey } from './usePageKey';
import { MyTrackerEvents, sendMtEvent, sendYaMetrikaEvent, YaMetrikaEvents } from '../../core/services/myTracker';

const PAGE_MAP: Record<PwaPage, ComponentType> = {
  [PwaPage.DisabledIos]: PwaDisabledIos,
  [PwaPage.DisabledAndroid]: PwaDisabledAndroid,
  [PwaPage.InstallSafari]: PwaInstallSafari,
  [PwaPage.InstallOldSafari]: PwaInstallOldSafari,
  [PwaPage.InstallChrome]: PwaInstallChrome,
  [PwaPage.InstallOther]: PwaInstallOther,
  [PwaPage.InstallDesktop]: PwaInstallDesktop,
};

const PAGE_MAP_TO_TRACKER_EVENTS: Record<PwaPage, { mt: MyTrackerEvents; ym: YaMetrikaEvents }> = {
  [PwaPage.DisabledIos]: {
    mt: MyTrackerEvents.PwaIosInstallDisabled,
    ym: YaMetrikaEvents.PwaIosInstallDisabled,
  },
  [PwaPage.DisabledAndroid]: {
    mt: MyTrackerEvents.PwaAndroidInstallDisabled,
    ym: YaMetrikaEvents.PwaAndroidInstallDisabled,
  },
  [PwaPage.InstallSafari]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallOldSafari]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallChrome]: {
    mt: MyTrackerEvents.PwaInstallInstructionOpened,
    ym: YaMetrikaEvents.PwaInstallInstructionOpened,
  },
  [PwaPage.InstallOther]: {
    mt: MyTrackerEvents.PwaCopyInstructionOpened,
    ym: YaMetrikaEvents.PwaCopyInstructionOpened,
  },
  [PwaPage.InstallDesktop]: {
    mt: MyTrackerEvents.PwaQrInstructionOpened,
    ym: YaMetrikaEvents.PwaQrInstructionOpened,
  },
};

export function PwaInstallController() {
  const { platform } = useAppContext();
  const pageKey = usePageKey();

  useEffect(() => {
    if (platform === 'ios') {
      linkIosManifest();
    }
  }, [platform]);

  useDidMount(() => {
    const event = PAGE_MAP_TO_TRACKER_EVENTS[pageKey];
    sendMtEvent(event.mt);
    sendYaMetrikaEvent(event.ym);
  });

  const Page = PAGE_MAP[pageKey];

  return <Page />;
}
